import React from "react";
import { Box, Flex, Stack, Text } from "@chakra-ui/react";
import Icon from "./ui-elements/Icon";

type Props = {
  [key: string]: any;
};

const EmptyJobList = ({ status, ...rest }: Props) => {
  return (
    <Flex
      bg="white"
      overflow="hidden"
      shadow="fbShadow"
      alignItems="stretch"
      flexShrink={0}
      borderRadius="fbRadius"
      borderWidth="3xs"
      direction="column"
      py={16}
    >
      <Flex
        align="center"
        px={[5, 6]}
        bg="white"
        direction="column"
        width="100%"
        {...rest}
      >
        <Stack align="center" width={["100%", "80%"]}>
          <Stack align="center" spacing={5}>
            <Icon name="empty-folder" color="orange.500" size={16} />

            <Stack align="center" textAlign="center">
              <Text fontWeight="medium" fontSize={["md", "lg"]}>
                You don't have a new request yet
              </Text>
              <Text>
                When clients hire you for lessons, it'll show up here.
              </Text>
            </Stack>
          </Stack>

          <Box pt={[5, 6]} width="100%">
            <Text mb={3} fontWeight="medium">
              Tips to get more bookings
            </Text>

            <Stack
              p={[4, 5]}
              isInline
              spacing={[3, 4]}
              bg="white"
              width="100%"
              borderWidth="2xs"
              borderColor="gray.300"
              borderRadius="fbRadius"
            >
              <Icon
                name="money-bag"
                display={["none", "block"]}
                mt={1}
                color="green.500"
                size={[5, 6]}
              />
              <Stack>
                <Text fontWeight="bold">Price lower to attract clients</Text>
                <Text>
                  Charge lower subject rates initially to get more requests,
                  then increase your price as you go.
                </Text>
              </Stack>
            </Stack>

            <Stack
              mt={5}
              p={[4, 5]}
              isInline
              spacing={[3, 4]}
              bg="white"
              width="100%"
              borderWidth="2xs"
              borderColor="gray.300"
              borderRadius="fbRadius"
            >
              <Icon
                mt={1}
                name="calendar"
                display={["none", "block"]}
                color="green.500"
                size={[5, 6]}
              />
              <Stack>
                <Text fontWeight="bold">Keep your calendar updated</Text>
                <Text>
                  Ensure that the days and times you're available for lessons
                  are always indicated in your schedule.
                </Text>
              </Stack>
            </Stack>
          </Box>
        </Stack>
      </Flex>
    </Flex>
  );
};

export default EmptyJobList;
